module.exports = __webpack_public_path__ + "img/master-card.542a55ba.png";